import { render } from "./SyllabusChapterDetailsPage.vue?vue&type=template&id=0f9ae9a0&ts=true"
import script from "./SyllabusChapterDetailsPage.vue?vue&type=script&lang=ts"
export * from "./SyllabusChapterDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__